export const safeFilteredUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
        console.error('Invalid redirect URL protocol:', url);
        return false;
    }
    const sanitizedUrl = url.replace(/[\x00-\x1F\x7F<>"'`]/g, '');
    try {
        const urlObj = new URL(sanitizedUrl);
        if (!['http:', 'https:'].includes(urlObj.protocol)) {
            console.error('Unsafe redirect protocol:', urlObj.protocol);
            return false;
        }
    }
    catch (e) {
        console.error('Invalid redirect URL:', e);
        return false;
    }
    return sanitizedUrl;
};
